<template>
  <BModal :model-value="modalFilter" title="Filter" hide-footer @update:modelValue="updateModal"> 
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5 class="">Filter</h5>
      </div>
      <BButton
        variant="link"
        class="close"
        @click="updateModal(false)"
      >
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <div class="form-group">
        <select name="" id="" class="form-control">
          <option value="" v-for="room, index in rooms" :key="index">{{ room }}</option>
        </select>
      </div>
     
    </BForm>
    <template #footer>
        <div class="d-flex justify-content-end">
            <BButton tton variant="light" @click="submitReservation" class="mr-2">Reset</BButton>
            <BButton variant="primary" @click="updateModal(false)">Filter</BButton>
        </div>
    </template>
  </BModal>
</template>

<script>
import { ref } from "vue";
import { 
  // BRow, BCol,
  BModal, BForm, BButton, 
  // BFormInput, 
} from "bootstrap-vue-next";

export default {

    name: 'RoomFilter',
    components: {
        BModal,
        // BRow, 
        // BCol,
        BButton,
        // BFormInput,
        BForm
    },
    props: {
        modalFilter: Boolean,
    },
    emits: ["update:modalFilter"],
    setup(props, {emit}){
        console.log(props)
        const rooms = ref([
          'Deluxe', 'Super Deluxe', 'Suite', 'Family', 'Honeymoon'
        ])
        const updateModal = (value) => {
                emit("update:modalFilter", value); // Sync modal state with parent
            };
        return{
            updateModal,
            rooms,
        }
    }
    

}
</script>

<style>

</style>